/* eslint-disable max-len, no-useless-escape */
import { cnpj } from 'cpf-cnpj-validator';

const cnpjRegex = /([0-9]{2}[\.]?[0-9]{3}[\.]?[0-9]{3}[\/]?[0-9]{4}[-]?[0-9]{2})|([0-9]{3}[\.]?[0-9]{3}[\.]?[0-9]{3}[-]?[0-9]{2})/;

const isValidCnpj = (cnpjInput) => cnpjRegex.test(cnpjInput) && cnpj.isValid(cnpjInput);

export { cnpjRegex, isValidCnpj };
